import React from 'react';
import _ from 'lodash'
import {Empty, Modal, Table} from 'antd'
import {withNamespaces} from "react-i18next";
import {LocalStore} from "../../utils/LocalStore";
import UserService from "../../services/user.service";
import {moneyFormat} from "../../utils/stringUtils";


class ModalMarkupRateGroups extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLoggedUser: {},
        };
    }

    // scroll top khi bắt đầu load trang
    componentDidMount() {
        this.setState({
            currentProjectInfo: LocalStore.getInstance().read('currentProjectInfo') || {},
            currentLoggedUser: LocalStore.getInstance().read('currentLoggedUser') || {}
        });
        this.getExchangeRate(this.getMarkupRateGroups)
    }

    /**
     * lấy ra danh sách trạng thái của package
     */
    getMarkupRateGroups = () => {
        const {exchangeRate = {}} = this.state;
        UserService.getMarkupRateGroups((err, res, headers) => {
            if (err === null) {
                let listExchangeRate = []
                if (Array.isArray(res.listMarkupRates)) {
                    res.listMarkupRates.map((item) => {
                        let arr = []
                        try {
                            arr = JSON.parse(item.viewTemplate)
                        } catch (err) {
                            arr = []
                        }

                        if (Array.isArray(arr) && arr.length > 0) {
                            let currency = ""
                            if (item.exchangeRate) {
                                currency = item.exchangeRate.split('/')
                            }

                            arr.map((x, y) => {
                                let res = 0
                                if (item.scope && item.scope.toLocaleLowerCase() === 'value') {
                                    res = exchangeRate.rate + parseFloat(x.price)
                                }
                                if (item.scope && item.scope.toLocaleLowerCase() === 'rate') {
                                    res = exchangeRate.rate + exchangeRate.rate*(parseFloat(x.price)/100)
                                }

                                listExchangeRate.push({
                                    base: currency[0],
                                    value: res,
                                    currency: currency[1]
                                })
                            })
                        }
                    })
                }

                this.setState({
                    markupRateGroups: res || {},
                    listExchangeRate: _.sortBy(listExchangeRate, ['value'])
                });
            }
        });
    };

    /**
     * lấy ra danh sách trạng thái của package
     */
    getExchangeRate = (cb) => {
        UserService.getExchangeRatePeerPayMent("", (err, res, headers) => {
            if (err === null) {
                this.setState({
                    exchangeRate: res || {},
                }, () => {
                    if (cb) cb()
                });
            }
        });
    };

    renderTableMarkupRates = (item, index) => {
        const {t, listPaymentMethods = []} = this.props
        const {exchangeRate = {}} = this.state;
        let arr = []

        try {
            arr = JSON.parse(item.viewTemplate)
        } catch (err) {
            arr = []
        }

        if (!Array.isArray(arr) || arr.length === 0) return <div key={index}/>
        let currency = ""
        if (item.exchangeRate) {
            currency = item.exchangeRate.split('/')
        }

        const columns = [{
            title: t('peer_payment.range'),
            dataIndex: 'code',
            key: 'code',
            render: (text, row) => {
                let strHtml = ""
                if (row.toAmount) {
                    strHtml = `Từ <strong>${moneyFormat(row.fromAmount, currency[0])}</strong> đến <strong>${moneyFormat(row.toAmount, currency[0])}</strong>`
                } else {
                    strHtml = `Trên <strong>${moneyFormat(row.fromAmount, currency[0])}</strong>`
                }
                return <div dangerouslySetInnerHTML={{__html: strHtml}}/>
            }
        }, {
            title: t('peer_payment.exchage_rate'),
            dataIndex: 'price',
            key: 'price',
            className: 'txt-right',
            render: (text, row) => {
                let res = 0
                if (item.scope && item.scope.toLocaleLowerCase() === 'value') {
                    res = exchangeRate.rate + parseFloat(text)
                }
                if (item.scope && item.scope.toLocaleLowerCase() === 'rate') {
                    res = exchangeRate.rate + exchangeRate.rate*(parseFloat(text)/100)
                }

                return moneyFormat(res, currency[1])
            },
        }];

        let group = listPaymentMethods.find(x => x.code === item.paymentMethodCode) || {}

        return <div key={index} className={`bg-color-gray2 pdbt15`}>
            <div className="bg-color-white">
                <div className="pd15 bold txt-color-black">
                    {group.name || '---'}
                </div>

                {
                    !Array.isArray(arr) || arr.length === 0 ?
                        <div className="bg-color-white border-bottom-radius">
                            <Empty
                                image={require('../../resources/images/empty-image.png')}
                                description={t('message.empty')}
                            />
                        </div>
                        :
                        <Table
                            className={'_table-data custom-empty table-expand-row border-bottom-radius'}
                            rowKey={(x, y) => y}
                            columns={columns}
                            dataSource={arr}
                            rowClassName={() => `_table-row`}
                            pagination={{
                                hideOnSinglePage: true,
                                pageSize: arr.length,
                            }}
                        />
                }
            </div>
        </div>
    }

    renderModalAddProduct = () => {
        const {t} = this.props;
        const {markupRateGroups = {}, listExchangeRate = []} = this.state;

        if (!listExchangeRate[0]) return <div/>
        let firstItem = listExchangeRate[0]
        let lastItem = listExchangeRate[listExchangeRate.length-1]
        let title = `${t('peer_payment.exchange_range')}: ${moneyFormat(1, firstItem.base)} = ${moneyFormat(firstItem.value, firstItem.currency)} - ${moneyFormat(lastItem.value, lastItem.currency)}`
        return <Modal
            className="modal-log-package-damage"
            title={title}
            visible={this.state.showModalAddProduct}
            onCancel={() => this.setState({
                showModalAddProduct: false
            })}
            width={600}
            cancelText={t('modal.confirm')}
            okButtonProps={{className: "dpl-none"}}
            cancelButtonProps={{className:"_btn-cancel-confirm"}}
        >
            <div>
                {
                    Array.isArray(markupRateGroups.listMarkupRates) && markupRateGroups.listMarkupRates.map((item, index) => this.renderTableMarkupRates(item, index))
                }
            </div>
        </Modal>
    };

    render() {
        const {t} = this.props;
        const {listExchangeRate = []} = this.state;

        if (!listExchangeRate[0]) return <div/>
        let firstItem = listExchangeRate[0]
        let lastItem = listExchangeRate[listExchangeRate.length-1]

        return <div className="dpl-il-block">
            <div
                onClick={() => {
                    this.setState({showModalAddProduct: true})
                }}
                className="_btn-modal-markup-rate-groups btn-modal-markup-rate-groups mgl15"
            >
                {t('peer_payment.exchange_range')}: {moneyFormat(1, firstItem.base)} = {moneyFormat(firstItem.value, firstItem.currency)} - {moneyFormat(lastItem.value, lastItem.currency)}
            </div>

            {this.renderModalAddProduct()}
        </div>
    }
}
export default withNamespaces()(ModalMarkupRateGroups)
